import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import useDebounce from '../../../utils/useDebounce';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type UpdateListData = {
	page: number;
	perPage: number;
	lancs: LancamentoData[];
};

type LancamentoData = {
	caixa: string;
	compensado: boolean;
	data: string;
	doc: string;
	fin_json: FinJsonDTO;
	id_lancamento: string;
	name_pay: string;
	nome: string;
	operacao: string;
	operacao_tipo: string;
	url_pay: string;
	vlr_cred: number;
	vlr_cred_formatted?: string;
	vlr_deb: number;
	vlr_deb_formatted?: string;
};

interface DTSearchParams {
	lancamentos: LancamentoData[];
	setPesqLancamentos: (titulo: LancamentoData[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (params: UpdateListData ) => void;
};

const searchKeys = [
	'caixa',
	'nome',
	'name_pay',
	'doc',
	'data',
	'operacao',
	'operacao_tipo',
	'vlr_cred_formatted',
	'vlr_deb_formatted',
];

const DTSearch: React.FC<DTSearchParams> = ({
	lancamentos,
	setPesqLancamentos,
  controls,
  setControls,
  handleUpdateList,
}) => {

  async function handlePesquisa(texto: string) {
    if (texto === '' || texto === ' ') {
			setPesqLancamentos(lancamentos);

      setControls({
        ...controls,
        page: 1,
				totalPage: Math.ceil(lancamentos.length / controls.perPage),
      });
			
			handleUpdateList({ page: 1, perPage: controls.perPage, lancs: lancamentos});
      return;
    };

		const results = search(lancamentos, searchKeys, texto) as LancamentoData[];

		setPesqLancamentos({ ...results });

    setControls({
      ...controls,
      page: 1,
      totalPage:  Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList({ page: 1, perPage: controls.perPage, lancs: results });
  };

	const debounceChange = useDebounce(handlePesquisa, 800);

  return (
		<Flex as="form" ml={["0", "0", "4"]} mb={2}>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
					onChange={e => debounceChange(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DTSearch;
